import { Cookies }                      from 'utils/index.js';
export const getLanguage = (selectedLanguage) => {
    return selectedLanguage || Cookies.getItem('selectedLanguage') || 'en';
};